import { render } from "./RecordConfirm.vue?vue&type=template&id=7c694c8b"
import script from "./RecordConfirm.vue?vue&type=script&lang=js"
export * from "./RecordConfirm.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src766051562/src/medoor-medical-records/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__